export const companyIco = "21836256";
